import React from 'react'

import { Switch, Redirect, Route } from 'react-router-dom'

import { GuestRouteWithLayout } from './components'
import { GuestsJourneyLayout, GuestsMainLayout } from './layouts'

import Forbidden from 'views/Forbidden'
import NotFound from 'views/NotFound'

import Journey from 'views/Guests/Journey'
import AiInventoryList from 'views/Guests/AiInventory/List'
import AiInventoryShow from 'views/Guests/AiInventory/Show'
import AiInventoryForm from 'views/Guests/AiInventory/Form'
import AiInventoryDaiRegistration from 'views/Guests/AiInventory/DaiRegistration'
import PrivacyByDesignList from 'views/Guests/PrivacyByDesign/List'
import PrivacyByDesignShow from 'views/Guests/PrivacyByDesign/Show'
import PrivacyByDesignForm from 'views/Guests/PrivacyByDesign/Form'

import useAuthGuest from 'hooks/useAuthGuest'

const GuestRoutes = () => (
  <Switch>
    {/* AI Inventory — protected routes */}
    <GuestRouteWithLayout
      path={routes.aiInventory.list}
      component={AiInventoryList}
      layout={GuestsMainLayout}
      auth
      exact
    />
    <GuestRouteWithLayout
      path={routes.aiInventory.daiNew}
      component={AiInventoryDaiRegistration}
      layout={GuestsMainLayout}
      auth
      exact
    />
    <GuestRouteWithLayout
      path={routes.aiInventory.new}
      component={AiInventoryForm}
      layout={GuestsMainLayout}
      auth
      exact
    />
    <GuestRouteWithLayout
      path={routes.aiInventory.edit}
      component={AiInventoryForm}
      layout={GuestsMainLayout}
      auth
      exact
    />
    <GuestRouteWithLayout
      path={routes.aiInventory.show}
      component={AiInventoryShow}
      layout={GuestsMainLayout}
      auth
      exact
    />

    {/* AI Inventory — journey (auth flow) */}
    <GuestRouteWithLayout
      path={routes.aiInventory.journey}
      component={Journey}
      layout={GuestsJourneyLayout}
      guestModule="ai_inventory"
      redirectPath={routes.aiInventory.list}
      exact
    />

    {/* Protected routes — specific before :id */}
    <GuestRouteWithLayout
      path={routes.privacyByDesign.list}
      component={PrivacyByDesignList}
      layout={GuestsMainLayout}
      auth
      exact
    />
    <GuestRouteWithLayout
      path={routes.privacyByDesign.new}
      component={PrivacyByDesignForm}
      layout={GuestsMainLayout}
      auth
      exact
    />
    <GuestRouteWithLayout
      path={routes.privacyByDesign.edit}
      component={PrivacyByDesignForm}
      layout={GuestsMainLayout}
      auth
      exact
    />
    <GuestRouteWithLayout
      path={routes.privacyByDesign.show}
      component={PrivacyByDesignShow}
      layout={GuestsMainLayout}
      auth
      exact
    />

    {/* Public: journey (auth flow) */}
    <GuestRouteWithLayout
      path={routes.privacyByDesign.journey}
      component={Journey}
      layout={GuestsJourneyLayout}
      guestModule="privacy_by_design"
      redirectPath={routes.privacyByDesign.list}
      exact
    />

    <Route
      render={() => <NotFound useAuthHook={useAuthGuest} />}
      exact
      path={[routes.notFound, routes.notFoundWithSlug]}
    />
    <Route component={Forbidden} exact path={routes.forbidden} />
    <Redirect to={routes.notFound} />
  </Switch>
)

export const routes = {
  notFound: '/guests/not-found',
  notFoundWithSlug: '/:organizationSlug/guests/not-found',
  forbidden: '/guests/forbidden',
  privacyByDesign: {
    journey: '/:organizationSlug/guests/:portalToken/privacy-by-design',
    list: '/:organizationSlug/guests/privacy-by-design/list',
    new: '/:organizationSlug/guests/privacy-by-design/new',
    edit: '/:organizationSlug/guests/privacy-by-design/:privacyByDesignId/edit',
    show: '/:organizationSlug/guests/privacy-by-design/:privacyByDesignId',
  },
  aiInventory: {
    journey: '/:organizationSlug/guests/:portalToken/ai-inventory',
    setup: '/:organizationSlug/guests/ai-inventory/setup',
    list: '/:organizationSlug/guests/ai-inventory/list',
    new: '/:organizationSlug/guests/ai-inventory/new',
    daiNew: '/:organizationSlug/guests/ai-inventory/new/dai',
    edit: '/:organizationSlug/guests/ai-inventory/:aiInventoryId/edit',
    show: '/:organizationSlug/guests/ai-inventory/:aiInventoryId',
  },
}

export default GuestRoutes
